import { Turnstile, TurnstileInstance } from '@marsidev/react-turnstile';
import { useRef, useEffect } from 'react';

interface TurnstileWidgetProps {
  onSuccess: (token: string) => void;
  onError?: () => void;
}

export function TurnstileWidget({ onSuccess, onError }: TurnstileWidgetProps) {
  const turnstileRef = useRef<TurnstileInstance>(null);
  const siteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY;

  useEffect(() => {
    // Reset on mount to ensure fresh token
    return () => {
      if (turnstileRef.current) {
        turnstileRef.current.reset();
      }
    };
  }, []);

  if (!siteKey) {
    console.error('VITE_TURNSTILE_SITE_KEY is not configured');
    return null;
  }

  return (
    <div className="flex justify-center my-4">
      <Turnstile
        ref={turnstileRef}
        siteKey={siteKey}
        onSuccess={onSuccess}
        onError={() => {
          console.error('Turnstile verification failed');
          onError?.();
        }}
        onExpire={() => {
          console.warn('Turnstile token expired, resetting');
          turnstileRef.current?.reset();
        }}
        options={{
          theme: 'light',
          size: 'normal',
          retry: 'auto',
        }}
      />
    </div>
  );
}
